/*
 *  Copyright (c) 2024 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Config } from "../config";
import { makeRequest } from "../common/index"

const base_url = Config.public.api_base_url
const context = Config.public.context
const endpoint = `/${context}/keyword`

/**
 * Fetch all keywords.
 * @param {string} token - The Bearer token for authorization.
 * @returns {Promise<Object>} - A promise that resolves to the list of all keywords.
 */
const getAllKeywords = async (token) => {
    const method = "GET"
    const path = `${endpoint}`
    const headers = { Authorization: `Bearer ${token}` };
    const payload = undefined;
    return await makeRequest(method, base_url, path, headers, payload);
};

/**
 * Fetch keywords associated with a specific GUID.
 * @param {string} token - The Bearer token for authorization.
 * @param {string} guid - The UUID associated with the resource.
 * @returns {Promise<Object>} - A promise that resolves to the keywords for the given GUID.
 */
const getKeywordsByGuid = async (token, guid) => {
    const method = "GET"
    const path = `${endpoint}/${guid}`
    const headers = { Authorization: `Bearer ${token}` }
    const payload = undefined
    return await makeRequest(method, base_url, path, headers, payload)
}

export {
    getAllKeywords,
    getKeywordsByGuid,
}
